export default Vue => {
  Vue.component("v-qrcode", () => import("./v-qrcode.vue"));
};
